import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import QInput from 'quasar/src/components/input/QInput.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';;
import ru from 'quasar/lang/ru';

// To be used on app.use(Quasar, { ... })
export default {
	config: {},
	plugins: {},
	components: {
		QInput,
		QBtn,
		QIcon
	},
	lang: ru
};
